import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

// Syncfusion Grid modules
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { ColumnChooserService, FilterService, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';

// Component
import { EligibilityDifferenceReportComponent } from './eligibility-difference-report.component';
import { CommonApiService } from 'src/app/service/commonapiservice';

// Services
// import { CommonApiService } from '../../services/commonapiservice';

const routes: Routes = [
  {
    path: '',
    component: EligibilityDifferenceReportComponent
  }
];

@NgModule({
  declarations: [
    EligibilityDifferenceReportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MaskedTextBoxModule,
    RouterModule.forChild(routes)
  ],
  providers: [
    ColumnChooserService,
    PageService,
    SortService,
    FilterService,
    ResizeService,
    CommonApiService
  ],
  exports: [
    EligibilityDifferenceReportComponent // Export for use in other modules
  ]
})
export class EligibilityDifferenceReportModule { }
